export default class CreateUsersCtrl{

  constructor($scope, GeneralSettingsSrv, $interval, $state, $stateParams, $mdDialog, GlobalConfig, $cookies, Validations){
    const createUserVM = this
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))
    // constants
    createUserVM.academicUnits = {}
    createUserVM.features = {}
    createUserVM.users = {}
    createUserVM.role = {}
    createUserVM.listOfAssignments = []
    createUserVM.constraints = []

    // variables
    createUserVM.selectedUnit = null
    createUserVM.selectedFeatures = []
    createUserVM.searchBy = "1"
    createUserVM.selectedUser = ""
    createUserVM.mappedFeatures = []
    createUserVM.isDisabled = false
    createUserVM.dataUsersGrid = {}    
    createUserVM.showAcademicUnit = false
    createUserVM.saveNewUser = false
    createUserVM.checkIsOverMax = checkIsOverMax
    createUserVM.numberMaxUser = 0
    createUserVM.uaIdDefault = 0

    // methods
    createUserVM.searchUsers = searchUsers
    createUserVM.exists = exists
    createUserVM.addPermissionToUser = addPermissionToUser
    createUserVM.validateForm = validateForm
    createUserVM.confirmDisableUser = confirmDisableUser

    // local variables
    var roleSelected = parseInt($stateParams.roleId)

    activate()
	  getAssignedUsers();

    function activate() {
      return getFormData()
    }

	  function getAssignedUsers(){          
      return GeneralSettingsSrv.getUsersWithRole.get().$promise.then((dataReturn) => {
        if(dataReturn.status === true){ 
          createUserVM.listOfAssignments=[]         
          dataReturn.data.forEach((user) => {            
            if(user.userRoleId == roleSelected) {
              createUserVM.listOfAssignments.push(user);
            }
          });
          checkIsOverMax()
        } else {
          console.log(dataReturn)
        }
      }).catch((err) => {
        console.log("communications failure with server: ", err)
      })
    }
	
    function getFormData() {
      return GeneralSettingsSrv.getFormData.get().$promise.then((dataReturn) => {
        if(dataReturn.status === true){
          createUserVM.academicUnits = dataReturn.academicUnits 
          createUserVM.features = dataReturn.features
          createUserVM.users = dataReturn.users

          _updateSelectedFeatures(dataReturn.permissions)

          dataReturn.roles.forEach((role) => {
            if (role.id_code === roleSelected) {
              createUserVM.role = role
            }
          })

          if(createUserVM.role.is_required_academicUnit == 1) 
          { createUserVM.showAcademicUnit = true}
          else{ createUserVM.showAcademicUnit = false}

          if (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminUnit) {
            validateUsersLimitsConstrains(dataReturn.countUsers,GlobalConfig.userRolesIds.adminUnit,2)            
          }else if (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminModule) {
            validateUsersLimitsConstrains(dataReturn.countUsers,GlobalConfig.userRolesIds.adminModule,2)
          }

          createUserVM.numberMaxUser  = createUserVM.role.nm_maxUsers
          if(createUserVM.role.id_academicUnit !==null){
            createUserVM.uaIdDefault = createUserVM.role.id_academicUnit
            createUserVM.academicUnits.forEach((au)=>{
              if(au.id_code == createUserVM.uaIdDefault)
                createUserVM.selectedUnit = au
            })    
          }

        } else {
          console.log(dataReturn)
        }
      }).catch((err) => {
        console.log("communications failure with server: ", err)
      })
    }

    function _showAddUserExists(userName)
    {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.userName = userName
          $scope.close = function() {
            $mdDialog.hide();
          }
        }],
        template: require('./addUserExistsModal.html'),
        clickOutsideToClose:false
      });
    }

    function addPermission(params,assignment) {
      var userExist = false
      createUserVM.saveNewUser = false

      let header = { }
      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)){
        header.userId = user.id
        header.rolId  = currentRoleId
      } 

      return GeneralSettingsSrv.getUsers.get(header).$promise.then((dataReturn) => {
        if(dataReturn.status === true){
          createUserVM.dataUsersGrid = dataReturn.data
          if(createUserVM.role.is_required_academicUnit === 1)
          {
            createUserVM.dataUsersGrid.forEach((dataUser) => {
              if(dataUser.userId === assignment.user.id_code &&
                dataUser.academicId === assignment.academicUnitId.id_code &&
                dataUser.userRoleId === createUserVM.role.id_code) {
                  userExist = true
                  $scope.userName = dataUser.userName
              }
            })
          } else {
            createUserVM.dataUsersGrid.forEach((dataUser) => {
              if(dataUser.userId === assignment.user.id_code &&
                dataUser.userRoleId === createUserVM.role.id_code) {
                  userExist = true
                  $scope.userName = dataUser.userName
              }
            })
          }
          if(userExist)
          {
            _updateUsersPermissionsAdded()
            _showAddUserExists($scope.userName)
            _resetForm()
          } else {
              return GeneralSettingsSrv.addPermission.post(params)
                .$promise.then((dataReturn) => {
                  if(dataReturn.status === true){
                    _updateUsersPermissionsAdded()
                    createUserVM.saveNewUser = true
                    _resetForm()
                    getAssignedUsers()
                  } else {
                    createUserVM.isDisabled = false
                  }
                }).catch((err) => {
                  console.log("communications failure with server: ", err)
                })
          }
        } else {
          console.log(dataReturn)
        }
      }).catch((err) => {
        console.log("communications failure with server: ", err)
      })
    }

    function searchUsers(text) {
      let matcher = new RegExp(text,'i')
      let arr = []
      createUserVM.users.forEach((user) => {
        if(createUserVM.searchBy === "1"){
          if (user.ds_fullname.match(matcher)) {
            arr.push(user)
          }
        }
        else {
          if(user.ds_identification.match(matcher)){
            arr.push(user)
          }
        }
      })
      return arr
    }

    function exists(item) {
      return createUserVM.selectedFeatures.indexOf(item.id_feature+'') > -1
    }

    function validateForm() {
      if ((createUserVM.selectedUnit === null && createUserVM.showAcademicUnit) || createUserVM.selectedUser == "" || createUserVM.selectedUser === null) {
        return true
      } else {
        return false
      }
    }

    function addPermissionToUser() {
      createUserVM.isDisabled = true
      var valueSelAcademicUnitId = null
      var valueSelAcademicUnit = null

      if(createUserVM.role.is_required_academicUnit === 1)
      {
        valueSelAcademicUnitId = createUserVM.selectedUnit.id_code
        valueSelAcademicUnit = createUserVM.selectedUnit
      }

      let params = [
        {
          roleId: createUserVM.role.id_code,
          academicUnitId: valueSelAcademicUnitId,
          userId: createUserVM.selectedUser.id_code
        }
      ]
      let assignment = {
        academicUnitId: valueSelAcademicUnit,
        user: createUserVM.selectedUser
      }
      
      addPermission(params,assignment)
    }

    function _updateSelectedFeatures(data){
      for(var pos in data){
        if(data[pos].roleId === roleSelected){
          if(data[pos].featuresIds.indexOf(',') > -1)
            createUserVM.selectedFeatures = data[pos].featuresIds.split(',')
          else
            createUserVM.selectedFeatures = data[pos].featuresIds
          return
        }
      }
    }

    function _showLimitOfUserReached(){
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.rolName = createUserVM.role.ds_name
          $scope.close = function() {
            $mdDialog.hide();
          }
        }],
        template: require('./limitOfUsersReachedModal.html'),
        clickOutsideToClose:false
      });
    }

    function validateUsersLimitsConstrains(restrictions,roleId,restrictionAmount){
      restrictions.forEach((constraint) => {
        if (constraint.id_role === roleId) {
          createUserVM.constraints.push(constraint)
          createUserVM.academicUnits.forEach((unit) => {
            if (unit.id_code === constraint.id_academicunits 
              && constraint.quantityUsers === restrictionAmount) {
              createUserVM.academicUnits.splice(createUserVM.academicUnits.indexOf(unit), 1)
            }
          })
        }
      })
      isEmptyAcademicUnits(createUserVM.academicUnits)
    }

    function _updateUsersPermissionsAdded(){
      if(createUserVM.role.is_required_academicUnit === 1)
      {
        createUserVM.constraints.forEach((constraint) => {
          if (constraint.id_academicunits === createUserVM.selectedUnit.id_code) {
            constraint.quantityUsers++
            if((createUserVM.role.id_code === GlobalConfig.userRolesIds.adminUnit && constraint.quantityUsers === 2) ||
              (createUserVM.role.id_code === GlobalConfig.userRolesIds.adminModule && constraint.quantityUsers === 2)){
              createUserVM.academicUnits.splice(createUserVM.academicUnits.indexOf(createUserVM.selectedUnit), 1)
            }
          }
        })   
      }
    }

    function confirmDisableUser(userAssigned,positionInArray){
      let user = userAssigned
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.user = user
          $scope.close = function() {
            $mdDialog.hide();
          }

          if(createUserVM.role.is_required_academicUnit === 1)
          {
            $scope.disableUser = function(entity){
              let params = {
                userId: entity.id_code,
                roleId: roleSelected,
                academicUnitId: entity.academicId
              }
              disablePermit(params, positionInArray, $mdDialog)
            }
          }
          else
          {
            $scope.disableUser = function(entity){
              let params = {
                userId: entity.id_code,
                roleId: roleSelected,
                academicUnitId: null
              }
              disablePermit(params, positionInArray, $mdDialog)
            }
          }
        }],
        template: require('../list/confirmDisableUserModal.html'),
        clickOutsideToClose:false
      })
    }

    function disablePermit(params, pos, dialog) {
      return GeneralSettingsSrv.disablePermit.post(params)
      .$promise.then((dataReturn) => {
        if(dataReturn.status === true){
          _resetForm()
          createUserVM.listOfAssignments.splice(pos, 1)         
          dialog.hide()          
        }
      }).catch((error) =>{
        console.log("communications failure with server")
      })
    }

    /*
    //No use, update method for utilization
    function isAlreadyAdded(){
      for(var elem in createUserVM.listOfAssignments){
        if(createUserVM.listOfAssignments[elem].academicUnitId.id_code == createUserVM.selectedUnit.id_code 
          && createUserVM.listOfAssignments[elem].user.id_code == createUserVM.selectedUser.id_code){
          return true
        }
      }
      return false
    }
    */

    function _resetForm(){
      createUserVM.selectedUnit = null
      createUserVM.selectedUser = ""
      createUserVM.isDisabled = false
      getFormData()
    }

    function isEmptyAcademicUnits(units){
      if(units.length === 0)
      {
        if(createUserVM.saveNewUser === true)
        {
          _showAddedPermissionAndLimitOfUserReached()
          createUserVM.saveNewUser = false
        }
        else
        {
          _showLimitOfUserReached()
        }
      }
      else
      {
        if(createUserVM.saveNewUser === true)
        {
          _showAddedPermissionModal()
          createUserVM.saveNewUser = false
        }        
      }
    }

    function _showAddedPermissionModal(){      
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.rolName = createUserVM.role.ds_name
          $scope.close = function() {
              $mdDialog.hide()
          }
        }],
        template: require('./addedPermissionModal.html'),
        clickOutsideToClose:false
      })
    }

    function _showAddedPermissionAndLimitOfUserReached(){
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.rolName = createUserVM.role.ds_name
          $scope.close = function() {
            $mdDialog.hide();
          }
        }],
        template: require('./addedPermissionAndLimitOfUserReached.html'),
        clickOutsideToClose:false
      });
    }

    function checkIsOverMax(){
      if(!typeof createUserVM.listOfAssignments != 'undefined' && createUserVM.numberMaxUser!==null &&createUserVM.listOfAssignments.length >= createUserVM.numberMaxUser){
        return true;
      }
    }

  }
}

CreateUsersCtrl.$inject = ['$scope','GeneralSettingsSrv','$interval', '$state', '$stateParams','$mdDialog', 'GlobalConfig', '$cookies', 'Validations'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/create/createUsersCtrl.js